import React, { Component } from 'react';
import { Form, FormGroup, Button, Row, Collapse } from 'reactstrap';
import { func } from 'prop-types';
import compact from 'lodash/compact';
import { FMessage, iFMessage } from '../../hoc/IntlComponents';
import ContractsIPForm from './ContractsIPForm';
import ContractsOOOForm from './ContractsOOOForm';
import ContractsFormControls from './ContractFormControls';
import fieldProps from './fieldProps';
import CustomControl from '../CustomControl/CustomControl';
import cn from 'classnames';
import ContractsSEForm from './ContractsSEForm';
import { injectIntl, FormattedMessage } from 'react-intl';
import { getFrontUrl } from '../../config';

const required = {
  self: [
    'name',
    'inn',
    'bik',
    'bank_account',
    'document_serial',
    'document_number',
    'document_unit_name',
    'document_date',
    'document_unit_code',
    'document_unit_code',
    'document_unit_code',
    'birthday',
    'address',
    'actual_address',
    'email',
    'phone',
    'edo_id',
  ],
  ip: [
    'name',
    'ogrnip',
    'inn',
    'address',
    'actual_address',
    'email',
    'phone',
    'bank_name',
    'bank_account',
    'bik',
    'corr_account',
    'edo_id',
  ],
  ooo: [
    'name',
    'owner',
    'ogrn',
    'inn',
    'kpp',
    'address',
    'actual_address',
    'contact_name',
    'email',
    'phone',
    'bank_name',
    'bank_account',
    'bik',
    'corr_account',
    'edo_id',
  ],
};

class ContractsForm extends Component {
  static propTypes = {
    onSubmit: func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      ip: props.selected ? props.selected : {},
      ooo: props.selected ? props.selected : {},
      self: props.selected ? props.selected : {},
      errors_ip: [],
      errors_ooo: [],
      errors_self: [],
      isFormOpened: false,
      isNotResident: true,
      consentChecked: true,
    };
  }

  onInputChange = ({ target: { name, value } }) => {
    const { type: contractType, types, inModal } = this.props;
    let type = !inModal ? types[contractType] : contractType;

    this.setState((prevState) => {
      const prevErrors = prevState[`errors_${type}`];
      const errorIndex = prevErrors.findIndex((value) => value === name);
      let nextErrors = [...prevErrors];
      if (errorIndex >= 0) {
        nextErrors[errorIndex] = null;
      }
      return {
        [type]: {
          ...prevState[type],
          [name]: value,
        },
        [`errors_${type}`]: compact(nextErrors),
      };
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.loading === true && this.props.loading) {
      this.setState(() => ({ isFormOpened: false }));
    }
  }

  getCommonProps = (key, labelIndex) => {
    const { disabled, types, type: contractType, inModal, intl } = this.props;

    let type = !inModal ? types[contractType] : contractType;
    let value = this.state[type][key];

    const { labelId, placeholder, placeholderId, ...restProps } = fieldProps[key];
    const error = this.state[`errors_${type}`]?.find((field) => field === key);
    const commonProps = {
      ...restProps,
      bsSize: 'sm',
      name: key,
      value: value ? value : '',
      onChange: this.onInputChange,
      disabled,
      error: error ? <FMessage id="main.error.required" /> : '',
    };

    if (labelId) {
      commonProps.id = `contracts.${labelIndex >= 0 ? labelId[labelIndex] : labelId}`;
    }

    if (placeholderId || placeholder) {
      commonProps.placeholder = placeholderId
        ? Array.isArray(placeholderId)
          ? iFMessage({ intl, id: `contracts.placeholder.${placeholderId[labelIndex]}` })
          : iFMessage({ intl, id: `contracts.placeholder.${placeholderId}` })
        : Array.isArray(placeholder)
        ? placeholder[labelIndex]
        : placeholder;
    }
    return commonProps;
  };
  getCustomCheckBoxId = (type) => {
    const { inModal } = this.props;
    return `contracts.checkbox.${type}${inModal ? '.inModal' : ''}`;
  };
  toggleForm = () => {
    this.setState(({ isFormOpened }) => ({ isFormOpened: !isFormOpened }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { onSubmit, toggleModal, inModal } = this.props;
    const currentType = this.getFormType();
    const data = this.state[currentType];
    if (!this.isInvalid(currentType, data)) {
      onSubmit(data);
      toggleModal();
    }
  };
  isInvalid = (type, data) => {
    const errors = [];

    required[type].forEach((field) => {
      if (!data[field] || !data[field].toString().length) {
        errors.push(field);
      }
    });
    this.setState(() => ({ [`errors_${type}`]: errors }));
    return errors.length;
  };

  getFormType = () => {
    const { types, type, inModal } = this.props;
    if (!inModal) {
      return types[type];
    } else {
      return type;
    }
  };

  handleChangeResident = () =>
    this.setState((prevState) => ({ isNotResident: !prevState.isNotResident }));

  handleChangeConsent = () =>
    this.setState((prevState) => ({ consentChecked: !prevState.consentChecked }));

  render() {
    const { isFormOpened, isNotResident, consentChecked } = this.state;
    const { types, handleTypeChange, inModal, toggleModal, disabled, isBlurred } = this.props;
    const type = this.getFormType();
    const frontUrl = getFrontUrl();

    return (
      <div className={cn('contracts-form', { 'contracts-form--hidden': isBlurred })}>
        {/* {!inModal &&
          <div
            className={`toggleBtn link ${isFormOpened ? 'padding-bottom' : ''}`}
            onClick={this.toggleForm}>
            <span className='collapse-symbol'>{isFormOpened ? '-' : '+'}</span>
            <FMessage id="contracts.details.add.btn" />
          </div>
        } */}
        <Form onSubmit={this.handleSubmit} autoComplete="off">
          <Collapse isOpen={true}>
            {!inModal && (
              <ContractsFormControls
                types={types}
                active={this.props.type}
                handleTypeChange={handleTypeChange}
              />
            )}
            <Row>
              {type === 'ip' && (
                <ContractsIPForm
                  getCommonProps={this.getCommonProps}
                  inModal={inModal}
                  customCheckBoxId={this.getCustomCheckBoxId('ip')}
                  disabled={disabled}
                />
              )}
              {type === 'ooo' && (
                <ContractsOOOForm
                  getCommonProps={this.getCommonProps}
                  inModal={inModal}
                  customCheckBoxId={this.getCustomCheckBoxId('ooo')}
                  disabled={disabled}
                />
              )}
              {type === 'self' && (
                <ContractsSEForm
                  getCommonProps={this.getCommonProps}
                  customCheckBoxId={this.getCustomCheckBoxId('ooo')}
                  disabled={disabled}
                />
              )}
            </Row>
            <div className="contracts-form-checkboxes">
              <FormGroup>
                <CustomControl
                  id={`isNotResident_${inModal ? this.state[type].id : ''}`}
                  className="custom-control-xs isNotResident"
                  name="isNotResident"
                  value="isNotResident"
                  onChange={this.handleChangeResident}
                  checked={isNotResident}
                  disabled={disabled}
                >
                  <FMessage id="contracts.residend" />
                </CustomControl>
              </FormGroup>

              <FormGroup>
                <CustomControl
                  id={`consent_${inModal ? this.state[type].id : ''}`}
                  className="custom-control-xs consent-checkbox"
                  name="consent"
                  value="consent"
                  onChange={this.handleChangeConsent}
                  checked={this.state.consentChecked}
                  disabled={disabled}
                >
                  <FormattedMessage
                    id="contracts.consent.text"
                    defaultMessage="Подтверждаю, что ознакомился с {privacyLink}, {termsLink}, даю согласие на {personalDataLink}"
                    values={{
                      privacyLink: (
                        <a
                          href={`${frontUrl}/privacy`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <FMessage id="contracts.consent.privacy" />
                        </a>
                      ),
                      termsLink: (
                        <a
                          href={`${frontUrl}/terms`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <FMessage id="contracts.consent.terms" />
                        </a>
                      ),
                      personalDataLink: (
                        <a
                          href={`${frontUrl}/privacy`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <FMessage id="contracts.consent.personalData" />
                        </a>
                      ),
                    }}
                  />
                </CustomControl>
              </FormGroup>
            </div>

            <FormGroup className="contracts-form-submit">
              <Button className="btn btn-sm" color="secondary" onClick={toggleModal}>
                <FMessage id="main.cancel" />
              </Button>
              <Button
                type="submit"
                className="btn"
                color="primary"
                onClick={this.onSubmit}
                disabled={!isNotResident || !consentChecked || disabled}
              >
                <FMessage id={!inModal ? 'contracts.details.add.btn' : 'main.save'} />
              </Button>
            </FormGroup>
          </Collapse>
        </Form>
      </div>
    );
  }
}

export default injectIntl(ContractsForm);
